// extracted by mini-css-extract-plugin
module.exports = {"linkPanel":"Omradekort_linkPanel__dr8B0","titleShort":"Omradekort_titleShort__2nrxY","titleLong":"Omradekort_titleLong__oh9rl"};